/* eslint-disable*/
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Filter } from 'lucide-react';
import moment from 'moment';
import analyticsAction from '@/Actions/analytics.actions';
import { featureList, filtersInfoChip, useQuery } from '@/Helpers';
import styles from './QCHistory.module.scss';
import QualityAnalysisListPage from './QualityAnalysisListPage';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';
import { Button } from '@/Components/ui/button';
import aiAnalyticsActions from '@/Actions/aiAnalytics.actions';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const options = [
	{
		label: 'Product Name',
		value: 'productName',
		placeholder: 'Search by Product Name',
	},
	{
		label: 'Order ID',
		value: 'orderId',
		placeholder: 'Search by Order ID',
	},
	{
		label: 'Item ID',
		value: 'itemId',
		placeholder: 'Search by Item ID',
	},
];

const filtersInfo = {
	header: {
		store: false,
		date: false,
		product: false,
		process: false,
		statusAndTypes: false,
	},
	store: {
		show: true,
		multiSelect: true,
		text: 'Store',
	},
	filteredStore: {
		show: true,
		multiSelect: true,
		text: 'From Outlet',
	},
	brand: {
		show: true,
		text: 'Select Brand',
	},
	product: {
		show: true,
		text: 'Undetected Products',
		singleSelect: true,
	},
	dateRangeOnly: {
		show: true,
		text: 'Date Range',
		enableOnlyBackwardSelection: true,
	},
	skuType: {
		show: true,
		text: 'Select SKU Type',
		multiSelect: true,
	},
	allProcessType: {
		show: true,
		multiSelect: true,
	},
	duplicate: {
		show: true,
		text: 'Duplicate',
		list: featureList,
	},
	validation: {
		show: true,
		text: 'Validation',
		list: featureList,
	},
	identified: {
		show: true,
		text: 'Identified',
		list: featureList,
	},
	feature: {
		show: true,
		text: 'Feature',
		list: featureList,
	},
};

const COLMAP = {
	'UY Id': 'id',
	Category: 'id',
	'Sub Category': 'id',
	'Sku Code': 'id',
	Store: 'storeName',
	'QC TIME': 'QCTime',
	'Order Id': 'OrderId',
	'Item Id': 'itemId',
	'Product Name': 'ProductName',
	'Inventory Type': 'ItemId',
	Validated: 'validation',
	Identified: 'identification',
	Features: 'annotated',
	Weight: 'Weight',
	Temp: 'Temp',
	qc: 'id',
	Count: 'count',
};

const TABLE_COLUMNS = [
	{
		title: 'UY Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'QC TIME',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Product Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sku Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Inventory Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Validated',
		config: {
			type: 'EDIT',
		},
	},
	{
		title: 'Identified',
		config: {
			type: 'ANNOTATE',
		},
	},
	{
		title: 'Features',
		config: {
			type: 'ANNOTATE',
		},
	},
	{
		title: 'Weight',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Count',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Temp',
		config: {
			type: 'DATA',
		},
	},
];
const exportInfo = {
	showExportBtn: true,
};

const QCHistoryListData = (props) => {
	const {
		data,
		setQCSearchResults,
	} = props;

	const location = useLocation();
	const dispatch = useDispatch();
	const [filters, setFilters] = useState({});
	const [search, setSearchValue] = useState({});
	const [aiFilter, setAiFilter] = useState({});
	const params = new URLSearchParams(location.search);
	const flag = params.get('flag');

	useEffect(() => {
		const obj = location?.aiFilter;
		if (obj) {
			setAiFilter(obj);
		}
	}, [location.search]);

	const tryFetchAiData = () => {
		if (!params.has('AI')) return;
		const aiFilter = [];
		Array.from(params.entries()).forEach(([key, val]) => {
			let value = val;
			if (
				key === 'AI' ||
				key === 'clear' ||
				key === 'from' ||
				key === 'to'
			) {
				return;
			}
			if (!Number.isNaN(Number(val))) value = Number(val);
			if (val === 'null') value = null;
			const type = 'equal';
			aiFilter.push({
				column: key,
				value,
				type,
			});
		});
		dispatch(aiAnalyticsActions.fetchAiQcData({
			req: {
				data: {
					aiFilter,
					dateRangeFilter: {
						from: params.get('from').includes('T')
							? params.get('from').split('T')[0]
							: params.get('from'),
						to: params.get('to').includes('T')
							? params.get('to').split('T')[0]
							: params.get('to'),
					},
				},
			}
		}));
	};

	useEffect(() => {
		tryFetchAiData();
	}, [location.search]);

	useEffect(() => {
		if (aiFilter) {
			Object.entries(aiFilter).forEach(([key, value]) => {
				params.set(key, value);
			});
			params.set('AI', true);
		}
	}, [aiFilter]);

	useEffect(() => {
		if (params.has('s_no_filter')) {
			const values = params.get('s_no_filter').replace(/['"]+/g, '').trim();;
			const sNoArray = values.split(',').map((ele) => {
				return Number(ele);
			});
			dispatch(aiAnalyticsActions.fetchAiQcData({
				req: {
					data: {
						sNoArray,
					},
				},
			}));
		}
		return () => {
			dispatch(analyticsAction.resetInventoryAnalyticsState({
				entity: 'QUALITY_ANALYTICS',
				method: 'LIST_DATA',
				data: [],
			}));
		};
	}, []);


	const generateData = () => {
		const filteredData = data?.filter((ele) => {
			if (search?.searchValue) {
				return (ele?.ProductName?.toLowerCase().trim().includes(search?.searchValue?.toLowerCase().trim()) ||
					ele?.OrderId?.toLowerCase().trim().includes(search?.searchValue?.toLowerCase().trim()) ||
					ele?.itemId?.toLowerCase().trim().includes(search?.searchValue?.toLowerCase().trim()));
			}
			return ele;
		});
		setQCSearchResults(
			search?.value,
			filteredData,
			search?.searchValue
		);
		return filteredData;
	};


	function fetchQcHistory(filterValue) {
		setFilters(filterValue);
		const req = {
			data: {
				brandFilter: filterValue?.brandFilter?.id ? [filterValue?.brandFilter?.id] : [],
				storeFilter: filterValue?.multiStore?.id ? filterValue?.multiStore?.id : [],
				fromStoreFilter: filterValue?.filterMultiStore?.id ? filterValue?.filterMultiStore?.id : [],
				processTypes: filterValue?.allProcessTypeMulti?.id ? filterValue?.allProcessTypeMulti?.id : [],
				skuTypes: filterValue?.skuTypeMulti,
				duplicate: filterValue?.duplicate === 'all' ? null : filterValue?.duplicate,
				validation: filterValue?.validation === 'all' ? null : filterValue?.validation,
				identified: filterValue?.identified === 'all' ? null : filterValue?.identified,
				feature: filterValue?.feature === 'all' ? null : filterValue?.feature,
				dateRangeFilter: {
					from: moment(filterValue?.dateRange?.from).format('YYYY-MM-DD'),
					to: moment(filterValue?.dateRange?.to).format('YYYY-MM-DD'),
				},
				product: filterValue?.product?.id ? [filterValue?.product?.id] : [],
				allProcessTypeMulti: filterValue?.allProcessTypeMulti?.id ? filterValue?.allProcessTypeMulti?.id : [],
			},
		};
		dispatch(analyticsAction.gateway({
			entity: 'QUALITY_ANALYTICS',
			req,
			method: 'LIST_DATA',
		})
		);
	}

	return (
		<div className={styles.root}>
			<ImagesFinder
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
				onSubmit={fetchQcHistory}
				avoidInitialCall={!flag || location?.aiFilter || params.has('AI') || params.has('s_no_filter')}
				allStoreOption={false}
			/>
			<p className='text-lg font-bold m-1'>AI Quality History</p>
			{!(
				location?.aiFilter ||
				params.has('AI') ||
				params.has('s_no_filter')
			) && (
					<>
						<div
							className='flex flex-1 items-baseline gap-3'
						>
							<div className='flex-1 min-w-0'>
								<GlobalSearch
									dropDownOptions={options}
									setSelectedValue={setSearchValue}
								/>
							</div>
							<span className='text-sm text-gray-500 font-bold'>
								Total Records:
								{data?.length}
							</span>
							<Button
								onClick={(e) => {
									dispatch(drawerActions.toggleFiltersDrawer(true, {
										handleDataExport: (exportFilters) => {
											const exportReq = {
												brandFilter: exportFilters?.brandFilter?.id ? [exportFilters?.brandFilter?.id] : [],
												storeFilter: exportFilters?.multiStore?.id ? exportFilters?.multiStore?.id : [],
												fromStoreFilter: exportFilters?.filterMultiStore?.id ? exportFilters?.filterMultiStore?.id : [],
												processTypes: exportFilters?.allProcessTypeMulti?.id ? exportFilters?.allProcessTypeMulti?.id : [],
												skuTypes: exportFilters?.skuTypeMulti,
												duplicate: exportFilters?.duplicate === 'all' ? null : exportFilters?.duplicate,
												validation: exportFilters?.validation === 'all' ? null : exportFilters?.validation,
												identified: exportFilters?.identified === 'all' ? null : exportFilters?.identified,
												feature: exportFilters?.feature === 'all' ? null : exportFilters?.feature,
												dateRangeFilter: {
													from: moment(exportFilters?.dateRange?.from).format('YYYY-MM-DD'),
													to: moment(exportFilters?.dateRange?.to).format('YYYY-MM-DD'),
												},
												product: exportFilters?.product?.id ? [exportFilters?.product?.id] : [],
												allProcessTypeMulti: exportFilters?.allProcessTypeMulti?.id ? exportFilters?.allProcessTypeMulti?.id : [],
											};
											dispatch(analyticsAction?.exportAiQcHistoryAnalytics(exportReq));
										},
									}));
								}}
								className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
							>
								<span className='text-nowrap'>Filter & Export</span>
								<Filter className='size-4' />
							</Button>
						</div>
						{filtersInfoChip(filtersInfo, filters)}
					</>
				)}
			<QualityAnalysisListPage
				data={generateData()}
				TABLE_COLUMNS={TABLE_COLUMNS}
				COLMAP={COLMAP}
			/>
		</div>
	);
};

QCHistoryListData.defaultProps = {};

const mapStateToProps = (state) => {
	const { LIST_DATA: data } = state.analytics.QUALITY_ANALYTICS;
	return {
		data,
	};
};

const mapDispatchToProps = {
	setQCSearchResults: analyticsAction.setQCSearchResults,
};
export default connect(mapStateToProps, mapDispatchToProps)(QCHistoryListData);
